// import React, { useState } from 'react';
// import{ CsvTicketFileUpload } from 'proxyUrl';
// import axios from 'axios';

// function UploadCSV() {
//   const [file, setFile] = useState(null);

//   const handleFileChange = (e) => {
//     setFile(e.target.files[0]);
//   };

//   const handleUpload = async () => {
//     if (!file) return alert("Please select a file");

//     const formData = new FormData();
//     formData.append("csvFile", file);

//     try {
//     //   const response = await axios.post("http://localhost:5000/upload", formData);
//           const response = await axios.post(CsvTicketFileUpload, formData);

//       alert(response.data.message);
//     } catch (err) {
//       console.error(err);
//       alert("Upload failed.");
//     }
//   };

//   return (
//     <div>
//       <input type="file" accept=".csv" onChange={handleFileChange} />
//       <button onClick={handleUpload}>Upload CSV</button>
//     </div>
//   );
// }

// export default UploadCSV;



// 





import React, { useState } from 'react';
import axios from 'axios';
import { CsvTicketFileUpload } from 'proxyUrl';
import "./ticket.css";

function UploadCSV() {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleRemove = () => {
    setFile(null);
  };

  const handleUpload = async () => {
    if (!file) return alert("Please select a file");

    const formData = new FormData();
    formData.append("csvFile", file);

    setUploading(true);
    try {
      const response = await axios.post(CsvTicketFileUpload, formData);
      alert(response.data.message);
      setFile(null); // Clear file after successful upload
    } catch (err) {
      console.error(err);
      alert("Upload failed.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-container">
      <h2>Upload CSV File</h2>
      

      <input
        type="file"
        accept=".csv"
        onChange={handleFileChange}
        className="file-input"
      />

      {file && (
        <div className="file-info">
          <p>{file.name}</p>
          <button className="remove-button" onClick={handleRemove}>
            Remove File
          </button>
        </div>
      )}

      <button
        onClick={handleUpload}
        className="upload-button"
        disabled={uploading || !file}
      >
        {uploading ? "Uploading..." : "Upload CSV"}
      </button>

      {/* 🔽 Download CSV Button */}
      {/* <a
        href="."
        download
        className="download-button"
        style={{ marginTop: "1rem", display: "inline-block" }}
      >
        Download Sample CSV
      </a> */}

      <button
        className="info-button"
        >
          <a href="/ticket.csv" target="_blank" rel="noopener noreferrer" className="info-button">
            Download CSV
          </a>
        </button>
    </div>
  );
}

export default UploadCSV;
